import { motion } from 'framer-motion';

const CTASection = () => {
  return (
    <section className="relative bg-[#0A1628] py-14 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 lg:px-8 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-display font-bold text-2xl lg:text-6xl text-white mb-4 lg:mb-6 leading-tight">
            Solicite uma Consultoria Técnica Especializada
          </h2>

          <p className="text-base lg:text-xl text-gray-300 mb-8 lg:mb-12 max-w-2xl mx-auto">
            Atendimento nas Regiões Metropolitanas de Sorocaba e Campinas
          </p>

          <motion.a
            href={`https://wa.me/5515996719308?text=${encodeURIComponent('Olá! Vim pela página inicial do site e gostaria de solicitar uma consultoria técnica.')}`}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="inline-flex items-center gap-3 bg-[#D4AF37] text-[#0A1628] px-8 lg:px-12 py-4 lg:py-5 rounded-full text-base lg:text-xl font-bold hover:bg-[#C19B2E] transition-all shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Falar com Especialista
            <i className="ri-arrow-right-line text-xl lg:text-2xl"></i>
          </motion.a>

          <div className="mt-10 lg:mt-16 flex flex-col lg:flex-row items-center justify-center gap-4 lg:gap-8 text-gray-400">
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-lg lg:text-xl"></i>
              <span className="text-xs lg:text-sm">(15) 99671-9308</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-mail-line text-lg lg:text-xl"></i>
              <span className="text-xs lg:text-sm">engeporto.contato@gmail.com</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line text-lg lg:text-xl"></i>
              <span className="text-xs lg:text-sm">Estamos sediados em Porto Feliz - SP</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
